














































import { Component, Mixins } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import { mapGetters } from 'vuex';
import Spinner from '@/components/Media/Spinner.vue';
import EventLogMethods from '@/mixins/EventLogMethods.vue';
import DateMethods from '@/mixins/DateMethods.vue';
import InfiniteScroll from '@/components/Scrolls/InfiniteScroll.vue';
import InfiniteLoading from 'vue-infinite-loading';

@Component({
    components: {
        Spinner,
        InfiniteScroll,
        InfiniteLoading,
    },
    computed: {
        ...mapGetters({
            eventLogsUnseen: 'EventLogs/getEventLogsUnseen',
        }),
    },
})
export default class EventLogsDropdown extends  Mixins(EventLogMethods, DateMethods) {
    public loaderAction: string = 'FETCH_EVENT_LOGS_UNSEEN';

    public beforeCreate() {
        this.$store.commit(Mutations.RESET_UNSEEN_EVENT_LOGS);
    }
}
